<template>
  <el-dialog
    title="折扣券返佣信息"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      size="small"
    >
      <el-form-item
              prop="business_id"
              label="一级分类"
              :rules="[{ required: true, message: '不能为空'}]"
      >
      <el-select
              class="filter-item"
              v-model="form.business_id"
              placeholder="请选择一级分类"
      >
        <el-option
                v-for="item in businessOptions"
                :key="item.businessid"
                :label="item.businessname"
                :value="item.businessid"
        ></el-option>
      </el-select>
      </el-form-item>

      <el-form-item
              prop="platform_scale"
              label="平台返佣"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.platform_scale"></el-input>
      </el-form-item>

      <el-form-item
              prop="one_agent_scale"
              label="一级代理返佣"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.one_agent_scale"></el-input>
      </el-form-item>
      <el-form-item
              prop="two_agent_scale"
              label="二级代理返佣"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.two_agent_scale"></el-input>
      </el-form-item>
      <el-form-item
              prop="three_agent_scale"
              label="三级代理返佣"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.three_agent_scale"></el-input>
      </el-form-item>
      <el-form-item
              prop="user_recom_scale"
              label="消费商家返佣"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.user_recom_scale"></el-input>
      </el-form-item>
      <el-form-item
              prop="consume_agent_scale"
              label="消费者返佣"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.consume_agent_scale"></el-input>
      </el-form-item>
      <el-form-item
              prop="shop_locking"
              label="推荐人返佣"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.shop_locking"></el-input>
      </el-form-item>

      <el-form-item
              prop="sharers_scale"
              label="分享返佣"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.sharers_scale"></el-input>
      </el-form-item>

      <el-form-item
              prop="drainage_coupon_scale"
              label="引流券商家返佣"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.drainage_coupon_scale"></el-input>
      </el-form-item>

      <el-form-item  v-if="formEdit">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as oneclassService from "@/api/sys/oneclass";
    import util from '@/libs/util.js'
export default {
  name: "smallposterEditForm",
  props: {
      oneclass: Object,
    value: Boolean
  },
  data() {
    return {
        formEdit: true,
      loading: false,
      dialogVisible: false,
        fileList: [],
      businessOptions: [],
      form: {
          advImg:""
      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
      this.$refs.form.resetFields();
      var formData25 = new FormData() // 声明一个FormData对象
      formData25.append('xt_id',util.cookies.get('xt_id'))
      oneclassService.getOneclass(formData25).then(data => {
        this.businessOptions=data;
      });

      if (this.oneclass.id) {
       // userService.getUser(this.user.id).then(data => {
          let form = {};
          form.business_id = this.oneclass.business_id;
          form.platform_scale = this.oneclass.platform_scale;
          form.one_agent_scale = this.oneclass.one_agent_scale;
          form.two_agent_scale = this.oneclass.two_agent_scale;
          form.three_agent_scale = this.oneclass.three_agent_scale;
          form.user_recom_scale = this.oneclass.user_recom_scale;

        form.consume_agent_scale = this.oneclass.consume_agent_scale;
        form.shop_locking = this.oneclass.shop_locking;
        form.sharers_scale = this.oneclass.sharers_scale;
        form.drainage_coupon_scale = this.oneclass.drainage_coupon_scale;

          this.form = form;
       // });
          this.formEdit = true;
      } else {
          this.formEdit = true;
          this.fileList =[];
        this.form = {};
      }
    },

    saveUser() {
      this.$refs["form"].validate(valid => {
        if (valid) {
                        this.loading = true;
            agentService.saveCouponRakeback({ ...this.form,agentid:util.cookies.get('agentid'), xt_id:util.cookies.get('xt_id'),id:this.oneclass.id})
                            .then(data => {
                                this.loading = false;
                                this.dialogVisible = false;
                                this.$emit("submit");
                            });


        } else {
          return false;
        }
      });
    },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

